import React, { useMemo } from 'react';

import useClasses from '../../hooks/useClasses';
import Icon from '../Icon';

import './style.scss';

export type ToastType = 'success' | 'info' | 'error';

interface Props {
  type: ToastType;
  text: React.ReactNode;
  className?: string;
  onDismiss?: () => void;
}

const CustomToast: React.FC<Props> = (props) => {
  const {
    type,
    text,
    className,
    onDismiss,
  } = props;

  const { buildClass, joinClasses } = useClasses('Toast', type);

  const iconName = useMemo(() => {
    switch (type) {
      case 'success': return 'thumbs-up';
      case 'error': return 'warning';
      case 'info': return 'info';
      default: return null;
    }
  }, [type]);

  return (
    <div className={joinClasses(buildClass(), className)}>
      <Icon icon={iconName} size="s" className={buildClass('icon')} />

      <p className={joinClasses(buildClass('text'), 'body--tiny', 'u-word-break')}>
        {text}
      </p>

      {onDismiss && (
        <button
          type="button"
          className={buildClass('dismiss')}
          onClick={onDismiss}
        >
          <Icon icon="cross" size="s" />
        </button>
      )}
    </div>
  );
};

export default CustomToast;
